import { taggedLogger } from '@/util';

const log = taggedLogger('safe-texture');

let _cachedMaxTextureSize: number | null = null;

/**
 * Query the GPU's MAX_TEXTURE_SIZE via a throwaway offscreen WebGL context.
 * Falls back to 4096 if WebGL is unavailable (e.g. test environments).
 * Result is cached after the first call.
 */
export function getMaxTextureSize(): number {
    if (_cachedMaxTextureSize !== null) return _cachedMaxTextureSize;

    try {
        const canvas = document.createElement('canvas');
        const gl =
            (canvas.getContext('webgl') ??
                canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null;
        if (gl) {
            _cachedMaxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) as number;
            const ext = gl.getExtension('WEBGL_lose_context');
            ext?.loseContext();
        }
    } catch {
        // Silently swallow — fallback below
    }

    if (_cachedMaxTextureSize === null) {
        log.warning('Could not query MAX_TEXTURE_SIZE; falling back to 4096');
        _cachedMaxTextureSize = 4096;
    }

    log.debug('MAX_TEXTURE_SIZE: %d', _cachedMaxTextureSize);
    return _cachedMaxTextureSize;
}
